import React from 'react';
import { motion } from 'framer-motion';
import { Target, Home, Sparkles, BarChart, ArrowRight } from 'lucide-react';
const audiences = [{
  icon: Target,
  title: 'TO estancados',
  desc: 'Repetís las mismas intervenciones sin ver progreso funcional real.'
}, {
  icon: Home,
  title: 'Domicilio o institución',
  desc: 'Con los recursos del hogar te alcanza. Sin equipamiento especial.'
}, {
  icon: Sparkles,
  title: 'Nuevos TO',
  desc: 'Querés posicionarte como referente en neurología degenerativa.'
}, {
  icon: BarChart,
  title: 'Resultados medibles',
  desc: 'Independencia en AVD, prevención de caídas, menos carga del cuidador.'
}];
export const TargetAudience = () => {
  return <section className="py-12 md:py-20 bg-navy text-white" data-id="element-348">
      <div className="max-w-5xl mx-auto px-4" data-id="element-349">
        <div className="text-center mb-8 md:mb-12" data-id="element-350">
          <h2 className="text-2xl md:text-4xl font-extrabold mb-2 md:mb-4 text-gold" data-id="element-351">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-sm md:text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-352">
            Diseñado para vos si querés llevar tu práctica al próximo nivel
          </p>
        </div>

        <div className="space-y-2.5 md:space-y-3" data-id="element-353">
          {audiences.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-center gap-3 md:gap-5 bg-navy-light/60 backdrop-blur-sm rounded-xl md:rounded-2xl border border-white/10 p-3 md:p-5 hover:border-teal/40 hover:bg-navy-light hover:translate-x-1 transition-all group" data-id="element-354">
                <div className="flex-shrink-0 w-11 h-11 md:w-14 md:h-14 rounded-full bg-teal/15 border border-teal/30 flex items-center justify-center group-hover:bg-teal group-hover:border-teal transition-colors" data-id="element-355">
                  <Icon className="w-5 h-5 md:w-6 md:h-6 text-teal group-hover:text-white transition-colors" data-id="element-356" />
                </div>
                <div className="flex-grow min-w-0" data-id="element-357">
                  <h3 className="text-base md:text-xl font-bold mb-0.5 md:mb-1 leading-tight" data-id="element-358">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-base text-gray-300 leading-snug" data-id="element-359">
                    {item.desc}
                  </p>
                </div>
                <ArrowRight className="hidden md:block w-5 h-5 text-white/30 group-hover:text-teal group-hover:translate-x-1 transition-all flex-shrink-0" data-id="element-360" />
              </motion.div>;
        })}
        </div>

        <div className="mt-8 md:mt-12 text-center" data-id="element-361">
          <a href="#pricing" className="inline-flex items-center gap-2 text-teal-light hover:text-teal font-medium text-sm md:text-base transition-colors" data-id="element-362">
            ¿No estás seguro si es para vos? Tenés 7 días de garantía
            <ArrowRight className="w-4 h-4" data-id="element-363" />
          </a>
        </div>
      </div>
    </section>;
};